import React from 'react';
import SvgIcon from './SvgIcon';

const HomeFull = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.75 11.625L12 1.875l11.25 9.75M20.25 7.125V3.75h-3.375M3.75 12.063V23.25H9v-7.5h6v7.5h5.25V12.031"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

HomeFull.displayName = 'HomeFullIcon';

export default HomeFull;
